import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { ZonaBarrio } from '../_models/zona-barrio';
import { map } from 'rxjs/operators';
import { ZonaHistoricoBarrio } from '../_models/zona-historico-barrio';

@Injectable({
  providedIn: 'root'
})
export class ZonaBarrioService {

  private serviceURL = AppSettings.rutServiciosAPL + '/api/zonasBarrios/';

  constructor( private authHttp: HttpClient, private authenticationService: AutenticacionService ) {
  }

  getAll() {
    return this.authHttp.get( this.serviceURL ).pipe( map( res => res as ZonaBarrio[] ) );
  }

  add( f: ZonaBarrio ) {
    f.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
    return this.authHttp.post( this.serviceURL, f )
      .pipe( map( res => res as any ) );
  }

  update( f: ZonaBarrio ) {
    f.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
    return this.authHttp.put( this.serviceURL, f ).pipe( map( res => res as any ) );
  }

  get( id: string ) {
    return this.authHttp.get( this.serviceURL + id )
      .pipe( map( res => res as ZonaBarrio ) );
  }

  getAllEnabled() {
    return this.authHttp.get( this.serviceURL + 'enabled' )
      .pipe( map( res => res as ZonaBarrio[] ) );
  }

  getAllByZona( idZona: string ) {
    return this.authHttp.get( this.serviceURL + 'zona/' + idZona )
      .pipe( map( res => res as ZonaBarrio[] ) );
  }

  getAllByZonaFull( idZona: string ) {
    return this.authHttp.get( this.serviceURL + 'barriosZona/' + idZona )
      .pipe( map( res => res as ZonaBarrio[] ) );
  }

  getAllByBarrio( idTipo: string, idMunicipio: string, idZona: string) {
    return this.authHttp.get( this.serviceURL + 'barrios/' + idTipo + '/' + idMunicipio + '/zona/' + idZona )
      .pipe( map( res => res as ZonaBarrio[] ) );
  }

  updateBulk( f: ZonaBarrio[] ) {

    for ( let i = 0; i < f.length; i++ ) {
      f[ i ].auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
    }

    return this.authHttp.put( this.serviceURL + 'bulk/', f ).pipe( map( res => res as any ) );
  }

  handleError( error: any ): Promise<any> {
    console.error( 'Error:', error );
    return Promise.reject( error.message || error );
  }

  getHistoryByZone( selectedZone: string ) {
    // return this.authHttp.get( this.serviceURL + 'historic' )
    return this.authHttp.get( this.serviceURL + 'historic/' + selectedZone )
      .pipe( map( res => res as ZonaHistoricoBarrio[] ) );
  }

  obtenerPorBarrio( idBarrio: string ) {
    return this.authHttp.get( this.serviceURL + 'barrio/' + idBarrio )
      .pipe( map( res => res as ZonaBarrio ) );
  }
}
